<script>
export default {
    name: "CashOutReport",

    data() {

        return {
            filter: {
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo:  window.moment().format(`YYYY-MM-DD`),
                search: '',
                user: ''
            },
            cashOuts: [],
            users: [],
        };
    },

    computed: {

        totalCashout() {
            if(!this.cashOuts.length) return 0;

            return this.cashOuts.map(cashOut => cashOut.amount ? parseFloat(cashOut.amount) : 0)
                    .reduce((amt, sum) => amt+sum);
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.allSettled([ this.fetchUsers(), ]).then(() => {
            this.fetchCashOut();
        }).catch(() => {
            this.$root.loading = false;
        });
    },

    methods: {

        fetchCashOut() {
            this.$root.loading = true;
            let url = `Admin/GetAuditTrail?Datefrom=${this.filter.dateFrom}&Dateto=${this.filter.dateTo}`;
            url += this.filter.user ? `&UserName=${this.filter.user}` : ``;
            url += this.filter.search ? `&SearchText=${this.filter.search}` : ``;
           
            this.$http.get(url).then(response => {
                this.cashOuts = response.data;
                this.$root.loading = false;
            }).catch(() => {
                this.$root.loading = false;
            });
        },

        fetchUsers() {

            return this.$http.get(`Admin/GetAuditTrailUsers`).then(response => {
                this.users = response.data;
            }).catch(() => {});
        },

        printCashOutReport() {

            window.open(`/reports/accounts-finance/cashout-report/print?dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}&user=${this.filter.user}`,
             '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-base-layout>
  <!-- <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link :to="{name : `reports.accounts-finance.index` }">Accounts & Finance Reports</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Cashout report</li>
           </ol>
         </nav>
      </div>
  </template> -->
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Audit Trail</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search" id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny"  v-if="$root.checkAuth('AccessOldData')
                ">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom"
                    id="grid-date-from" class="input-control input-sm text-xs" >
              </div> 
              <div class="md:w-1/6 sm:w-full p-tiny"  v-if="!$root.checkAuth('AccessOldData')">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" :min="$root.minFilterDate"
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.dateTo" id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-user" class="label-control">User:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select v-model.trim="filter.user" id="grid-user" class="input-control input-sm text-xs">
                              <option value="">All users</option>
                              <option v-for="(user, idx) in users" :key="idx" :value="user">{{ user }}</option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchCashOut"><i class="fa fa-filter"></i> Filter</button>
              </div>
             
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="cashOutTable">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="flex w-full">
                            <th class="p-tiny w-1/6">Date</th>
                            <th class="p-tiny w-1/6">Station</th>
                            <th class="p-tiny w-1/12">IP Address</th>
                            <th class="p-tiny w-1/2">Activity</th>
                             <th class="p-tiny w-1/6">Username</th> 
                        </tr>
                  </thead>
                  <!-- <tfoot>
                        <tr class="flex w-full">
                            <th class="p-tiny w-1/6"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/12"></th>
                            <th class="p-tiny w-1/3 text-right">Total Amt: {{ totalCashout | numberFormat }}</th>
                        </tr>
                  </tfoot> -->
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:65vh;">
                      <tr class="w-full flex" v-for="(cashOut, idx) in cashOuts" :key="idx">
                        <td class="p-tiny w-1/6">{{ cashOut.sysDate }}</td>
                          <td class="p-tiny w-1/6">{{ cashOut.loginstationname }}</td>
                          <td class="p-tiny w-1/12">{{ cashOut.loginstationip }}</td>
                          <td class="p-tiny w-1/2">{{ cashOut.trxtype }}</td>
                           <td class="p-tiny w-1/6">{{ cashOut.username }}</td>
                           
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>